import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  FormControl,
  Form,
  Modal,
  ListGroup,
  Image,
  InputGroup,
} from "react-bootstrap";
import {
  ListarDestaques,
  CadastrarDestaques,
  EditarDestaque,
  DeletarDestaque,
} from "../../providers/ProdutosDestaqueProvider";
import { api_url_destaques_image } from "../../providers/api";
import TBLDestaques from "../../components/TBLDestaques";
import TBLProdutos from "../../components/TBLProdutos";
import { getUser } from "../../services/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { listarProdutos } from "../../providers/ProdutosProvider";
import { BuscarProdutoPorNomeOuSku } from "../../providers/BuscaProvider";
import { ListarCorredores } from "../../providers/CorredoresProvider";
import Select from "react-select";

export default class ProdutosDestaque extends Component {
  constructor(props) {
    super(props);
    this.state = {
      destaqueSelecionado: null,
      showModalPromocoes: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarDestaque: false,
      pages: 1,
      page: 1,
      limit: 10,
      loading: false,
      destaques: [],
      descricao: "",
      produtos: [],
      produtosSelecionados: [],
      corredores: [],
      corredorSelecionado: null,
      imagem: null,
      busca: "",
      mensagemAlert: "",
      variantAlert: "",
      carregarDadosTabela: true,
    };

    this.fileInput = null;
  }

  handleCloseModalPromocoes = () => {
    this.setState({ showModalPromocoes: false });
    this.limparForm();
  };

  handleShowModalDestaque = () => {
    this.setState({ showModalPromocoes: true });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else {
      toast.error(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  fileChangedHandler = (event) => {
    this.setState({ imagem: event.target.files[0] });
  };

  removerProdutoSelecionado = (index) => {
    let produtos = this.state.produtosSelecionados;
    produtos = produtos.filter((item, i) => i !== index);
    this.setState({ produtosSelecionados: produtos });
  };

  limparForm = () => {
    this.setState({
      destaqueSelecionado: null,
      showModalPromocoes: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarDestaque: false,

      descricao: "",
      produtosSelecionados: [],
      corredorSelecionado: null,
      imagem: null,

      mensagemAlert: "",
      variantAlert: "",
    });
  };

  preencherFormEdit = (dados) => {
    this.setState({
      destaqueSelecionado: dados,
      descricao: dados.descricao,
      produtosSelecionados: dados.produtos,
      corredorSelecionado: dados.corredor
        ? {
            label: dados.corredor?.nome,
            value: dados.corredor?._id,
          }
        : null,
      modoEditarDestaque: true,
    });
    this.handleShowModalDestaque();
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.preencherFormEdit(dados);
    } else if (tipo === "deletar") {
      this.setState({ destaqueSelecionado: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  receberDadosTabelaProdutos = (tipo, produto) => {
    let selecionados = this.state.produtosSelecionados;
    if (!selecionados.filter((item) => item._id === produto._id).length) {
      this.setState({
        produtosSelecionados: [...this.state.produtosSelecionados, produto],
      });
    }
  };

  cadastrarDestaque = async () => {
    let form = new FormData();
    let { descricao, imagem, produtosSelecionados, corredorSelecionado } = this.state;
    if (descricao === "" || imagem === null) {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
    } else if (!corredorSelecionado && !produtosSelecionados.length) {
      this.setState({
        errorCadastro: "Selecione um corredor ou selecione os produtos manualmente",
      });
    } else {
      produtosSelecionados.forEach((item, i) => {
        form.append(`produtos[${i}]`, item._id);
      });
      form.append(`descricao`, descricao);
      form.append(`imagem`, imagem);
      form.append(`corredor`, corredorSelecionado?.value);
      let usuario = await getUser();
      form.append(`estabelecimento`, usuario.estabelecimento._id);
      try {
        const response = await CadastrarDestaques(form);
        if (response) {
          const list = await ListarDestaques();
          this.setState({ destaques: list });
          this.limparForm();
          this.handleShowAlert("Destaque cadastrado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao cadastrar destaque", "danger");
      }
    }
  };

  editarDestaque = async () => {
    let form = new FormData();
    let formJson = {};
    let {
      descricao,
      imagem,
      produtosSelecionados,
      destaqueSelecionado,
      corredorSelecionado,
    } = this.state;
    if (descricao === "") {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
    } else if (!corredorSelecionado && !produtosSelecionados.length) {
      this.setState({
        errorCadastro: "Selecione um corredor ou selecione os produtos manualmente",
      });
    } else {
      let usuario = await getUser();
      if (imagem) {
        form.append(`imagem`, imagem);
        produtosSelecionados.forEach((item, i) => {
          form.append(`produtos[${i}]`, item._id);
        });
        form.append(`descricao`, descricao);
        form.append(`corredor`, corredorSelecionado?.value || null);
        form.append(`estabelecimento`, usuario.estabelecimento._id);
      } else {
        formJson = {
          descricao: descricao,
          produtos: produtosSelecionados?.map((i) => i._id),
          estabelecimento: usuario.estabelecimento._id,
          corredor: corredorSelecionado?.value || null,
        };
      }

      try {
        let response = null;
        if (imagem) {
          response = await EditarDestaque(form, destaqueSelecionado._id);
        } else {
          response = await EditarDestaque(formJson, destaqueSelecionado._id);
        }
        if (response) {
          const list = await ListarDestaques();
          this.setState({ destaques: list });
          this.limparForm();
          this.handleShowAlert("Destaque editado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao cadastrar destaque", "danger");
      }
    }
  };

  deletarDestaque = async () => {
    const { destaqueSelecionado } = this.state;
    try {
      const response = await DeletarDestaque(destaqueSelecionado._id);
      if (response) {
        const list = await ListarDestaques();
        this.setState({ destaques: list });
        this.limparForm();
        this.handleShowAlert("Destaque excluido com sucesso", "success");
      }
    } catch (error) {
      this.handleShowAlert("Erro ao excluir destaque", "danger");
    }
  };

  listarDestaques = async () => {
    try {
      const destaques = await ListarDestaques();
      this.setState({ destaques });
    } catch (error) {
      this.setState({ destaques: [] });
    }
  };

  listarProdutos = async (current_page) => {
    this.setState({ loading: true });
    const { docs, page, pages } = await listarProdutos(current_page);
    if (docs) {
      this.setState({
        produtos: docs,
        pages,
        page,
        loading: false,
        limit: 10,
      });
    }
  };

  listProdutos = async () => {
    const { docs } = await listarProdutos();
    this.setState({ produtos: docs });
  };

  buscarDestaques = async (busca) => {
    const format = this.state.destaques.filter((d) =>
      d.descricao.toLowerCase().includes(busca),
    );
    if (format.length) {
      this.setState({ destaques: format });
    }
    if (!busca) {
      await this.listarDestaques();
    }
  };

  buscarProdutos = async (busca) => {
    if (busca !== "") {
      const response = await BuscarProdutoPorNomeOuSku(busca);
      this.setState({ produtos: response, carregarDadosTabela: false });
    } else {
      this.listProdutos();
      this.setState({ carregarDadosTabela: true });
    }
  };

  listarCorredores = async () => {
    const corredores = await ListarCorredores();
    this.setState({
      corredores: corredores.map((item) => ({
        label: item.nome,
        value: item._id,
      })),
    });
  };

  async componentDidMount() {
    await this.listarProdutos();
    await this.listarDestaques();
    await this.listarCorredores();
  }

  render() {
    return (
      <div>
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Destaques</h3>
          </Col>
          <Col>
            <Button
              onClick={() => {
                this.handleShowModalDestaque();
              }}
            >
              Cadastrar Destaques
            </Button>
          </Col>
        </Row>
        <br></br>

        {this.state.destaques.length ? (
          <div>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                placeholder="Pesquisar destaques pela descrição"
                onChange={(e) => this.buscarDestaques(e.target.value)}
              />
            </InputGroup>
            <TBLDestaques
              data={this.state.destaques}
              numRows={5}
              dataCallback={this.receberDadosTabela}
              showAcoes={true}
            ></TBLDestaques>
          </div>
        ) : (
          <h5>Nenhum destaque cadastrado</h5>
        )}

        <Modal
          size="xl"
          show={this.state.showModalPromocoes}
          onHide={this.handleCloseModalPromocoes}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarDestaque ? "Editar destaque" : "Cadastrar destaque"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.modoEditarDestaque ? (
              <div style={{ width: "100%", textAlign: "center", marginBottom: 20 }}>
                <Image
                  rounded
                  style={{ width: 60, height: 60 }}
                  src={
                    api_url_destaques_image + this.state.destaqueSelecionado.foto_destaque
                  }
                ></Image>
              </div>
            ) : null}
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group>
                <Form.Label>Descrição *</Form.Label>
                <Form.Control
                  value={this.state.descricao}
                  type="text"
                  placeholder="Descrição do destaque"
                  onChange={(e) => {
                    this.setState({ descricao: e.target.value });
                  }}
                />
              </Form.Group>
              {!this.state.produtosSelecionados.length && (
                <Form.Group>
                  <Form.Label>Corredor</Form.Label>
                  <Select
                    value={this.state.corredorSelecionado}
                    options={this.state.corredores}
                    onChange={(e) => {
                      this.setState({ corredorSelecionado: e });
                    }}
                    isClearable
                    placeholder="Corredor"
                  ></Select>
                </Form.Group>
              )}
              <Form.Group>
                <Form.Label>Imagem Banner *</Form.Label>
                <input
                  className={"form-control"}
                  type="file"
                  accept="image/x-png,image/gif,image/jpeg"
                  ref={(ref) => (this.fileInput = ref)}
                  onChange={this.fileChangedHandler}
                ></input>
                <Form.Text>
                  O banner deve ter as seguinter dimensões - Largura: 600px, Altura: 300px
                </Form.Text>
              </Form.Group>
              {!this.state.corredorSelecionado && (
                <>
                  <Form.Group>
                    <Form.Label>
                      Produtos selecionados: {this.state.produtosSelecionados.length}
                    </Form.Label>
                    <Row>
                      <Col>
                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                          {this.state.produtosSelecionados.map((item, i) => {
                            return (
                              <ListGroup.Item key={i}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: 250,
                                  }}
                                >
                                  <div>
                                    <div
                                      style={{
                                        height: "auto",
                                        maxHeight: "50px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      <b>{item.nome}</b>
                                    </div>
                                    <p>
                                      R$
                                      {parseFloat(
                                        item.preco.preco_encarte
                                          ? item.preco.preco_encarte
                                          : item.preco.preco_original,
                                      ).toFixed(2)}
                                    </p>
                                  </div>
                                  <Button
                                    size="sm"
                                    variant="danger"
                                    style={{ marginLeft: 10 }}
                                    onClick={() => this.removerProdutoSelecionado(i)}
                                  >
                                    X
                                  </Button>
                                </div>
                              </ListGroup.Item>
                            );
                          })}
                        </div>
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group>
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <FormControl
                        placeholder="Pesquisar produtos por código"
                        onChange={(e) => {
                          this.setState({
                            carregarDadosTabela: e !== "" ? false : true,
                          });
                          this.buscarProdutos(e.target.value);
                        }}
                      />
                    </InputGroup>
                    <TBLProdutos
                      data={this.state.produtos}
                      changePage={(p) => this.listarProdutos(p)}
                      limit={this.state.limit}
                      pages={this.state.pages}
                      loading={this.state.loading}
                      showAcoes={true}
                      isSelecao={true}
                      dataCallback={this.receberDadosTabelaProdutos}
                    ></TBLProdutos>
                  </Form.Group>
                </>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalPromocoes();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarDestaque ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.editarDestaque();
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarDestaque();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir o destaque?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarDestaque();
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
